<div 
  class="fixed inset-0 backdrop-blur-sm flex items-center justify-center z-[9999]"
  style="background-color: rgba(37, 134, 129, 0.8);"
  *ngIf="isVisible">
  

  <div class="bg-[#0B1739] rounded-xl shadow-2xl p-8 mx-4 max-w-md w-full border-2" style="border-color: #643bf7;">
    
    <div class="flex justify-center mb-6">
      <div class="rounded-full p-4" style="background-color: rgba(37, 134, 129, 0.1);">
        <mat-icon fontIcon="error" class="text-6xl w-16 h-16" style="color: #643bf7;"></mat-icon>
      </div>
    </div>
    
    <h2 class="text-2xl font-semibold text-center mb-4" style="color: #643bf7;">
      {{ title || 'You currently do not have permission to access any features in this application.' }}
    </h2>
    
    <p class="text-gray-600 text-center mb-8 leading-relaxed text-base">
      {{ message || 'Please contact your administrator to request the necessary access rights for your role.' }}
    </p>
    
    <div class="flex justify-center">
      <button 
        mat-raised-button 
        class="text-white font-medium text-white py-3 px-6 rounded-lg transition-all duration-200 flex items-center gap-2 min-w-[140px] shadow-lg hover:shadow-xl transform hover:scale-105"
        style="background-color: #643bf7; border-color: #643bf7;"
        onmouseover="this.style.backgroundColor='#1e6b66'"
        onmouseout="this.style.backgroundColor='#643bf7'"
        (click)="onLogout()">
        <mat-icon class="text-xl">exit_to_app</mat-icon>
        <span>Logout</span>
      </button>
    </div>
    
    <p class="text-xs text-gray-400 text-center mt-6">
      This session will remain blocked until you logout
    </p>
    
  </div>
  
  <div class="absolute inset-0 opacity-10 pointer-events-none">
    <div class="absolute inset-0" style="background-image: repeating-linear-gradient(45deg, transparent, transparent 2px, rgba(255,255,255,.1) 2px, rgba(255,255,255,.1) 4px);"></div>
  </div>
  
</div>